export function evalPathExpr(expression: string, context: Record<string, any>) {
    const parts = expression.split('.');
    let value = context;
    while (parts.length && value && typeof value === 'object') {
        const arrayAccess = /^([^[]+)\[(\d+)]$/.exec(parts[0]);
        if (arrayAccess) {
            const [, key, index] = arrayAccess;
            value = value[key][parseInt(index, 10)];
        } else {
            value = value[parts[0]];
        }
        parts.shift();
    }
    return value;
}
